// API Endpoints
export const USER_ENDPOINTS = {
    STORE_USERS: (storeId: string) => `/v1/stores/${storeId}/users`,
    INVITE_USER: (storeId: string) => `/v1/stores/${storeId}/invite`,
    UPDATE_USER: (storeId: string, userId: string) => `/v1/stores/${storeId}/users/${userId}`,
    DELETE_USER: (storeId: string, userId: string) => `/v1/stores/${storeId}/users/${userId}`,
} as const;


// Error Messages
export const USER_ERROR_MESSAGES = {
    INVITE_USER_FAILED: 'Failed to add user',
    UPDATE_USER_FAILED: 'Failed to update user',
    DELETE_USER_FAILED: 'Failed to delete user',
    UPDATE_CASHIER_MODE_PIN_FAILED: 'Failed to update cashier-mode PIN',
    UPDATE_CASHIER_MODE_PIN_FORBIDDEN: 'You do not have permission to update cashier-mode PIN',
} as const;

// Success Messages
export const USER_SUCCESS_MESSAGES = {
    USER_INVITED: 'User added successfully',
    USER_UPDATED: 'User updated successfully',
    USER_DELETED: 'User removed successfully',
    CASHIER_MODE_PIN_UPDATED: 'Cashier-mode PIN updated successfully',
    CASHIER_MODE_PIN_CLEARED: 'Cashier-mode PIN cleared successfully',
} as const;
